import getAuthSession from './auth';
import axios from 'axios';
import { AssessorProfile } from '../interfaces/users.interface';

export async function updateAssessorProfile(assessorProfile: AssessorProfile) {
  const authSession = await getAuthSession();
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_API}/assessor-profiles/${assessorProfile.id}/`,
    { ...assessorProfile },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as AssessorProfile;
}
